var map = {
	"./chinatown1.jpg": 4766,
	"./chinatown10.jpg": 3607,
	"./chinatown11.jpg": 9954,
	"./chinatown12.jpg": 2978,
	"./chinatown13.jpg": 444,
	"./chinatown14.jpg": 1108,
	"./chinatown15.jpg": 3251,
	"./chinatown16.jpg": 3677,
	"./chinatown17.jpg": 1688,
	"./chinatown18.jpg": 5511,
	"./chinatown19.jpg": 1775,
	"./chinatown2.jpg": 3258,
	"./chinatown20.jpg": 7084,
	"./chinatown21.jpg": 7764,
	"./chinatown22.jpg": 6740,
	"./chinatown23.jpg": 6452,
	"./chinatown3.jpg": 2808,
	"./chinatown4.jpg": 9357,
	"./chinatown5.jpg": 6694,
	"./chinatown6.jpg": 7642,
	"./chinatown7.jpg": 5280,
	"./chinatown8.jpg": 8954,
	"./chinatown9.jpg": 8251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4899;